import React from "react";
import Layout from "../../layout";
import "../contactUs/Cms.scss";
import { useAppSelector } from "../../hooks/store";
import { getCms } from "../../reducers/generalSlice";

const PrivacyPolicy = () => {
  const getCmsData = useAppSelector(getCms);

  return (
    <Layout>
      <div className="common_policy privicy">
        <div className="container">
          <div className="privt_one">
            <h1>Privacy Policy</h1>
            <p
              className={getCmsData ? "about_txt" : "about_txt2"}
              dangerouslySetInnerHTML={{
                __html: getCmsData
                  ? getCmsData?.privacyPolicy
                  : "Information not found",
              }}
            />

            {/* <p>
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less normal
              distribution of letters, as opposed to using ‘Content here,
              content here’, making it look like readable English. Many desktop
              publishing packages and web page editors now use Lorem Ipsum as
              their default model text, and a search for ‘lorem ipsum’ will
              uncover many web sites still in their infancy. Various versions
              have evolved over the years, sometimes by accident, sometimes on
              purpose (injected humour and the like).
            </p>

            <p>
              {" "}
              It is a long established fact that a reader will be distracted by
              the readable content of a page when looking at its layout. The
              point of using Lorem Ipsum is that it has a more-or-less normal
              distribution of letters, as opposed to using ‘Content here,
              content here’, making it look like readable English. Many desktop
              publishing packages and web page editors now use Lorem Ipsum as
              their default model text, and a search for ‘lorem ipsum’ will
              uncover many web sites still in their infancy. Various versions
              have evolved over the years, sometimes by accident, sometimes on
              purpose (injected humour and the like).
            </p> */}
          </div>
          {/* <h2>Personal Data Processing</h2>
          <p>
            It is a long established fact that a reader will be distracted by
            the readable content of a page when looking at its layout. The point
            of using Lorem Ipsum is that it has a more-or-less normal
            distribution of letters, as opposed to using ‘Content here, content
            here’, making it look like readable English. Many desktop publishing
            packages and web page editors now use Lorem Ipsum as their default
            model text, and a search for ‘lorem ipsum’ will uncover many web
            sites still in their infancy. Various versions have evolved over the
            years, sometimes by accident, sometimes on purpose (injected humour
            and the like).
          </p>
          <ul className="privcy_dv">
            <li>
              <h3>1. Data Controller</h3>
              <p>
                Lorem Ipsum has been the industry’s standard dummy text ever
                since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </p>
            </li>

            <li>
              <h3> 2. Website Use Under Terms And Conditions</h3>
              <p>
                Lorem Ipsum has been the industry’s standard dummy text ever
                since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </p>
            </li>

            <li>
              <h3> 3. Our Purposes And Lawful Basis Of Data We Collect</h3>
              <p>
                Lorem Ipsum has been the industry’s standard dummy text ever
                since the 1500s, when an unknown printer took a galley of type
                and scrambled it to make a type specimen book.
              </p>
            </li>
          </ul> */}
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
